export type ID = number | string;

export interface APIPaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export enum ApiErrorCodes {
  TimeFrameError = "DINE-5002",
}

export enum EndpointService {
  Core = "core",
  Gateway = "gateway",
  Reports = "reports",
}
